import { IPublicClientApplication } from "@azure/msal-browser";
import { authenticateOnScope, scopePowerBi } from "./common";

export interface PowerBiReportInfo {
    reportId: string;
    accessToken: string;
    embedUrl: string;
};

export enum PowerBiReportType {
    Main,
    Overview
}

export const loadPowerBiReport = async (instance: IPublicClientApplication, reportType: PowerBiReportType): Promise<PowerBiReportInfo> => {
    const tokenResponse = await authenticateOnScope(instance, scopePowerBi);
    const reportId = await getPowerBiReportId(reportType);
    const responseReportUrl = await fetch('/env/getPowerBiReportUrl', {
        method: 'GET',
        headers: new Headers({
            'xct-user-context': tokenResponse.accessToken,
            'x-pb-report-id': reportId,
            'Content-Type': 'application/json'
        })
    });
    const embedUrl = await responseReportUrl.text();
    return { reportId: reportId, accessToken: tokenResponse.accessToken, embedUrl: embedUrl };
};

export const getPowerBiReportId = async (reportType: PowerBiReportType): Promise<string> => {
    const key = "MpPowerBiReportId_" + reportType.toString();
    if (!localStorage.getItem(key)) {
        const response = reportType == PowerBiReportType.Main ? await fetch('/env/getPowerBiReportId', { method: "GET" }) : await fetch('/env/getPowerBiOverviewReportId', { method: "GET" });
        const reportId = await response.text();
        localStorage.setItem(key, reportId);
        return reportId;
    }
    return localStorage.getItem(key);
};